module.exports = __webpack_public_path__ + "img/bg2.285f23f4.png";